import axios from 'axios';
import { buildRequest, clearLocalCorporateStorage, TOKEN_TYPE } from '../utils/auth';

const token = document.getElementById('header')?.getAttribute('data-token') || process.env.WEB_TOKEN || '';
const server = process.env.SERVER_URL;

export const corporateCommonInstance = axios.create({
  timeout: 10000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    Authorization: token,
  },
  baseURL: window.location.origin + '/wp-json/token/v1/corporate', //v2
});

export const corporateAuthInstance = axios.create({
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
  baseURL: server + '/api',
});

corporateAuthInstance.interceptors.request.use(
  async (request) => {
    return buildRequest(request);
  },
  (error) => {
    clearLocalCorporateStorage();
    return Promise.reject(error);
  },
);

corporateAuthInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error;
    if (response.status === 401) {
      clearLocalCorporateStorage();
      const request = await buildRequest(config);
      return axios(request);
    }
    return Promise.reject(error);
  },
);

corporateCommonInstance.interceptors.response.use((res) => {
  localStorage.setItem(TOKEN_TYPE.CORPORATE_SPARE, res.data);
  return res;
});
